// src/app/services/router-state-tracker.service.ts
import { Injectable, OnDestroy } from '@angular/core'; // Added OnDestroy
import { Router, NavigationEnd, Event as RouterEvent, NavigationStart } from '@angular/router';
import { filter } from 'rxjs/operators';
import { BehaviorSubject, Subscription, Observable } from 'rxjs'; // Added Observable, Subscription
import { NavController } from '@ionic/angular'; // Import NavController

@Injectable({
  providedIn: 'root',
})
export class RouterStateTrackerService implements OnDestroy {
  private _previousUrlSubject = new BehaviorSubject<string>('/');
  private _currentUrlSubject = new BehaviorSubject<string>('/');
  private _startUrlSubject = new BehaviorSubject<string>('/'); // This seems to track a specific start, not general
  private _activePageRef = new BehaviorSubject<any | null>(null);
  private routerEventSubscription: Subscription;
    private _isNavigatingSubject = new BehaviorSubject<boolean>(false);
  isNavigating$ = this._isNavigatingSubject.asObservable();

  // isNavigating: boolean = false;
  stateData: any;
  combinedData: { [key: string]: any } = {};
  constructor(private router: Router, private navCtrl: NavController) {
    this._currentUrlSubject.next(this.router.url.split('?')[0]);
    this._startUrlSubject.next(this.router.url.split('?')[0]);

    this.routerEventSubscription = this.router.events.pipe(filter((event: RouterEvent): event is NavigationEnd => event instanceof NavigationEnd)).subscribe(
      (event: NavigationEnd) => {
        const newUrlPath = event.urlAfterRedirects.split('?')[0];
        this._previousUrlSubject.next(this._currentUrlSubject.getValue());
        this._currentUrlSubject.next(newUrlPath);
      },
      (error) => {
        console.error('RouterStateTrackerService: Error observing router events:', error);
      },
    );
  }

  ngOnDestroy() {
    if (this.routerEventSubscription) {
      this.routerEventSubscription.unsubscribe();
    }
  }

  registerActivePage(page: any): void {
    if (page) {
      const componentInstance = page as any;
      if (this._activePageRef.getValue() !== componentInstance) {
        this._activePageRef.next(componentInstance);
      }
    } else {
      if (this._activePageRef.getValue() !== null) {
        this._activePageRef.next(null);
      }
    }
  }

  unregisterActivePage(page: any): void {
    // Use `any` here
    if (this._activePageRef.getValue() === page) {
      this._activePageRef.next(null);
    }
  }
  updateCombinedData(key: string, newData: any): void {
    this.combinedData[key] = newData;
  }
  async navigateWithPreExitAnimation(url: string, pageData: any = {}, options?: any): Promise<boolean> {
    if (this._isNavigatingSubject.getValue()) {
      return false;
    }
    this.updateCombinedData(url, pageData);
    this._isNavigatingSubject.next(true); // ✅ emit true
    const activePage = this._activePageRef.getValue();

    if (activePage) {
      try {
        await activePage.playPreExitAnimation();

        this.stateData = options;
        const result = await this.navCtrl.navigateRoot(url, options);
        return result;
      } catch (error) {
        return await this.navCtrl.navigateRoot(url, options);
      } finally {
      this._isNavigatingSubject.next(false); // ✅ emit false when done
      }
    } else {
      this._isNavigatingSubject.next(false); // ✅ emit false when done
      return await this.navCtrl.navigateRoot(url, options);
    }
  }

  setStartUrl(url: string): void {
    this._startUrlSubject.next(url.split('?')[0]);
  }

  getTabUrl(): string {
    if (this._currentUrlSubject.getValue() === '/') {
      return this._startUrlSubject.getValue();
    }
    return this._currentUrlSubject.getValue();
  }

  getPreviousUrl(): string {
    return this._previousUrlSubject.getValue();
  }

  getCurrentUrl(): string {
    return this._currentUrlSubject.getValue();
  }
}
